import { api } from "./axios";
import type { Subtype } from "../types";

export interface StartStreamResponse {
  stream_id: string;
  stream_name: string;
  ws_url: string;
  webrtc_url: string;
}

export async function startStream(
  device_id: number,
  channel: number,
  subtype: Subtype,
  opts: { transcode?: boolean } = {},
): Promise<StartStreamResponse> {
  const r = await api.post("/streams/start", {
    device_id,
    channel,
    subtype,
    ...(opts.transcode ? { transcode: true } : {}),
  });
  return r.data;
}

export async function stopStream(stream_id: string): Promise<void> {
  await api.post("/streams/stop", { stream_id });
}

export async function swapSubtype(stream_id: string, new_subtype: Subtype): Promise<StartStreamResponse> {
  const r = await api.post("/streams/swap-subtype", { stream_id, new_subtype });
  return r.data;
}
